/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.warning\":[\"Warning triangle with exclamation point\"]}");